// import { createStore } from 'vuex'
//
// export default createStore({
//   state: {
//   },
//   getters: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })

import { createStore } from 'vuex'

export default createStore({
  state: {
    // 标签页状态
    tabs: [
      {
        title: '首页',
        name: '/dashboard',
        path: '/dashboard',
        closable: false
      }
    ],
    activeTab: '/dashboard',
    cachedViews: ['Dashboard'],

    // 用户信息
    user: {
      name: '',
      avatar: '',
      role: '',
      permissions: []
    }
  },

  getters: {
    // 标签页相关
    tabCount: state => state.tabs.length,
    currentTab: state => state.tabs.find(tab => tab.name === state.activeTab),

    isLoggedIn: state => {
      return !!(state.user.name && state.user.permissions && state.user.permissions.length > 0)
    },
    userRole: state => state.user.role
  },

  mutations: {
    // 标签页相关 mutations
    ADD_TAB(state, tab) {
      const exists = state.tabs.find(t => t.path === tab.path)
      if (!exists) {
        state.tabs.push(tab)
      }
      localStorage.setItem('cachedTabs', JSON.stringify(state.tabs))
    },

    REMOVE_TAB(state, tabName) {
      state.tabs = state.tabs.filter(tab => tab.name !== tabName)
      localStorage.setItem('cachedTabs', JSON.stringify(state.tabs))
    },

    SET_ACTIVE_TAB(state, tabName) {
      state.activeTab = tabName
    },

    CLOSE_OTHER_TABS(state, targetName) {
      state.tabs = state.tabs.filter(tab =>
          tab.name === targetName || tab.name === '/dashboard'
      )
      localStorage.setItem('cachedTabs', JSON.stringify(state.tabs))
    },

    CLOSE_ALL_TABS(state) {
      state.tabs = state.tabs.filter(tab => tab.name === '/dashboard')
      state.activeTab = '/dashboard'
      localStorage.setItem('cachedTabs', JSON.stringify(state.tabs))
    },

    ADD_CACHED_VIEW(state, view) {
      if (!state.cachedViews.includes(view)) {
        state.cachedViews.push(view)
      }
    },

    REMOVE_CACHED_VIEW(state, view) {
      const index = state.cachedViews.indexOf(view)
      if (index > -1) {
        state.cachedViews.splice(index, 1)
      }
    },

    RESET_TABS(state) {
      state.tabs = [
        {
          title: '首页',
          name: '/dashboard',
          path: '/dashboard',
          closable: false
        }
      ]
      state.activeTab = '/dashboard'
      state.cachedViews = ['Dashboard']
      localStorage.removeItem('cachedTabs')
    },

    SAVE_TABS(state) {
      localStorage.setItem('cachedTabs', JSON.stringify(state.tabs))
      localStorage.setItem('activeTab', state.activeTab)
    },
    LOAD_TABS(state) {
      const cachedTabs = localStorage.getItem('cachedTabs')
      const activeTab = localStorage.getItem('activeTab')
      if (cachedTabs) {
        state.tabs = JSON.parse(cachedTabs)
      }
      if (activeTab) {
        state.activeTab = activeTab
      }
    },

    SET_USER_INFO(state, userData) {
      state.user = {
        name: userData.realName || userData.name || '',
        avatar: userData.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
        role: userData.role?.name || '普通用户',
        permissions: []
      }
      if (Array.isArray(userData.permissions)) {
        state.user.permissions = userData.permissions.map(p => {
          return typeof p === 'string' ? p : (p.code || p.permissionCode || p)
        }).filter(Boolean)
      } else if (typeof userData.permissionCode === 'string') {
        state.user.permissions = [userData.permissionCode]
      }
    },

    CLEAR_USER_INFO(state) {
      state.user = {
        name: '',
        avatar: '',
        role: '',
        permissions: []
      }
    }
  },

  actions: {
    initStore({ commit }) {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr)
          commit('SET_USER_INFO', userInfo)
        } catch (error) {
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userPermissions')
        }
      }
      commit('LOAD_TABS')
    },

    addTab({ commit, state }, routeInfo) {
      const { path, name, meta } = routeInfo
      const noTabPaths = ['/login', '/404', '/401', '/', '/redirect']
      if (noTabPaths.includes(path) || !name || !meta?.title) return
      const newTab = {
        title: meta.title || name,
        name: path,
        path,
        closable: path !== '/dashboard'
      }
      commit('ADD_TAB', newTab)
      commit('SET_ACTIVE_TAB', path)

      if (meta?.keepAlive && name) {
        const componentName = name.charAt(0).toUpperCase() + name.slice(1)
        commit('ADD_CACHED_VIEW', componentName)
      }
      commit('SAVE_TABS')
    },

    removeTab({ commit, state }, targetName) {
      if (targetName === '/dashboard') return

      const tabsList = state.tabs
      let activeName = state.activeTab

      if (activeName === targetName) {
        const tabIndex = tabsList.findIndex(tab => tab.name === targetName)
        let newActiveName = '/dashboard'

        if (tabIndex > 0) {
          newActiveName = tabsList[tabIndex - 1].name
        }
        else if (tabIndex < tabsList.length - 1) {
          newActiveName = tabsList[tabIndex + 1].name
        }
        activeName = newActiveName
      }
      commit('SET_ACTIVE_TAB', activeName)
      commit('REMOVE_TAB', targetName)
      commit('SAVE_TABS')
    },

    closeOtherTabs({ commit, dispatch }, targetName) {
      commit('CLOSE_OTHER_TABS', targetName)
      commit('SET_ACTIVE_TAB', targetName)
      dispatch('navigateToTab', targetName)
    },

    closeAllTabs({ commit, dispatch }) {
      commit('CLOSE_ALL_TABS')
      dispatch('navigateToTab', '/dashboard')
    },

    navigateToTab({ commit }, tabPath) {
      commit('SET_ACTIVE_TAB', tabPath)
    },

    updateTabTitle({ commit, state }, { path, newTitle }) {
      const tab = state.tabs.find(t => t.path === path)
      if (tab) {
        tab.title = newTitle
      }
    },

    resetTabs({ commit }) {
      commit('RESET_TABS')
    },

    setUserInfo({ commit }, userData) {
      commit('SET_USER_INFO', userData)
    },

    clearUserInfo({ commit, dispatch }) {
      commit('CLEAR_USER_INFO')
      dispatch('resetTabs')
    }
  }
})
